import { CheckCircleOutlined, CloseCircleOutlined, HeartFilled, HeartOutlined, StopOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import cls from 'classnames'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { EventInfoFragment, useEventParticipantCreateUpdateMutation } from '@/generated/graphql'

import s from './event-card.module.less'

export const EventActions: React.FC<{ data: EventInfoFragment; hasDivider?: boolean; iconOnly?: boolean }> = ({
  data,
  hasDivider = true,
  iconOnly = false,
}) => {
  const { t } = useTranslation()
  const [createUpdateEventParticipant] = useEventParticipantCreateUpdateMutation()

  const isOpen = moment().diff(moment(data.deadline)) > 0

  return (
    <div className={cls(s.actions, { [s.hasDivider]: hasDivider })}>
      <Tooltip title={'有点兴趣，暂时观望'}>
        <Button
          type='link'
          icon={data.isInterested ? <HeartFilled className={s.like} /> : <HeartOutlined className={s.like} />}
          onClick={() =>
            createUpdateEventParticipant({
              variables: {
                input: {
                  postId: data.postId,
                  eventId: data.eventId,
                  isInterested: !data.isInterested,
                  isParticipated: data.isParticipated,
                },
              },
            })
          }
        >
          {iconOnly ? '' : t('calendar.interested')}
        </Button>
      </Tooltip>
      <Tooltip title={data.isParticipated ? '临时有事，无法出席' : '确定参加，绝不咕咕'}>
        <Button
          type='link'
          disabled={isOpen}
          icon={
            isOpen ? (
              <StopOutlined />
            ) : data.isParticipated ? (
              <CloseCircleOutlined className={s.participate} />
            ) : (
              <CheckCircleOutlined className={s.participate} />
            )
          }
          onClick={() =>
            createUpdateEventParticipant({
              variables: {
                input: {
                  postId: data.postId,
                  eventId: data.eventId,
                  isInterested: data.isInterested,
                  isParticipated: !data.isParticipated,
                },
              },
            })
          }
        >
          {iconOnly ? '' : t(`calendar.${isOpen ? 'pastDue' : data.isParticipated ? 'notParticipate' : 'participate'}`)}
        </Button>
      </Tooltip>
    </div>
  )
}
